import React, { useState } from 'react'
import MemberInfoModal from 'components/OurTeam/MemberInfoModal';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import parser from 'html-react-parser'
import { v4 as uuidv4 } from 'uuid';

export default function Directors({ data }) {
    const { directorsText, directorsTitle, directorsBlocks, directorsBackgroundColor } = data;

    const [selectedTeamMember, setSelectedTeamMember] = useState(null);
    const uniqueId = uuidv4(); // Generate a unique ID for this instance of the Directors component

    const handleOpen = block => setSelectedTeamMember(block);
    const handleClose = e => {
        if (e.target.classList.contains('modal')) setSelectedTeamMember(null);
    };
    
    return (
        <>
            <div
                id='board-directors'
                className={`executive-wrap light-grey-bg panel-space-70 ${directorsBackgroundColor}`}
            >
                <div className='container'>
                    <div className='row sm-text-center'>
                        <div className='col-md-3'>
                            <h2 className='heading-level-2 blue-color'>{directorsTitle && parser(directorsTitle)}</h2>
                        </div>
                        <div className='col-md-9'>
                            <p>{directorsText && parser(directorsText)}</p>
                        </div>
                    </div>
                    <div className='row team-row h-center'>
                        {directorsBlocks?.map((block, i) => (
                            <button
                                type='button'
                                data-bs-toggle='modal'
                                data-bs-target={`#director_description${uniqueId}`}
                                onClick={() => handleOpen(block)} className='col-md-2 col-6 team-col' key={i}>
                                <figure className='team-profile-image'>
                                    <GatsbyImage
                                        image={getImage(block.directorsImage?.localFile)}
                                        alt='image'
                                    />
                                </figure>
                                <div
                                    className='team-name'
                                    type='button'
                                    data-bs-toggle='modal'
                                    data-bs-target={`#director_description${uniqueId}`}
                                    onClick={() => handleOpen(block)}
                                >
                                    {block.directorsName}
                                </div>
                                {block.directorsPosition && (
                                    <div className='team-position-text'>
                                        {block.directorsPosition}
                                    </div>
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            <MemberInfoModal
                id={`director_description${uniqueId}`}
                onClose={handleClose}
                image={selectedTeamMember?.directorsImage.localFile}
                name={selectedTeamMember?.directorsName}
                position={selectedTeamMember?.directorsPosition}
                pronouns={selectedTeamMember?.directorsPronounce}
                facebookLink={selectedTeamMember?.directorsFacebookLink}
                email={selectedTeamMember?.directorsEmail}
                description={selectedTeamMember?.directorsDescription}
            />
        </>
    )
}
